/* Mondō London — restrained, progressive record reveals. */
(function () {
  'use strict';

  function initHoverPreview(root) {
    var preview = root.querySelector('[data-event-hover-preview]');
    var finePointer = window.matchMedia &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!preview || !finePointer) return;

    var activeRow = null;

    function hidePreview() {
      activeRow = null;
      preview.classList.remove('is-visible');
    }

    function placePreview(event) {
      var width = preview.offsetWidth || 220;
      var height = preview.offsetHeight || 275;
      var x = event.clientX + 24;
      var y = event.clientY - (height / 2);

      if (x + width + 12 > window.innerWidth) x = event.clientX - width - 24;
      x = Math.max(12, x);
      y = Math.max(12, Math.min(y, window.innerHeight - height - 12));
      preview.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
    }

    root.addEventListener('pointerover', function (event) {
      var row = event.target.closest ? event.target.closest('[data-event-thumb]') : null;
      if (!row || !root.contains(row)) return;

      activeRow = row;
      var source = row.getAttribute('data-event-thumb');
      if (preview.getAttribute('src') !== source) preview.setAttribute('src', source);
      placePreview(event);
      preview.classList.add('is-visible');
    });

    root.addEventListener('pointermove', function (event) {
      if (!activeRow) return;
      placePreview(event);
    });

    root.addEventListener('pointerout', function (event) {
      var row = event.target.closest ? event.target.closest('[data-event-thumb]') : null;
      if (!row || row.contains(event.relatedTarget)) return;
      hidePreview();
    });

    root.addEventListener('pointerleave', hidePreview);
    window.addEventListener('scroll', hidePreview, { passive: true });
  }

  function initEventsShell(root) {
    if (!root || root.dataset.eventsInitialised === 'true') return;
    root.dataset.eventsInitialised = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-event-reveal]'));
    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!reduceMotion && 'IntersectionObserver' in window && items.length) {
      root.classList.add('is-enhanced');

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, {
        threshold: 0.06,
        rootMargin: '0px 0px -10% 0px'
      });

      items.forEach(function (item) { observer.observe(item); });
    } else {
      items.forEach(function (item) { item.classList.add('is-visible'); });
    }

    initHoverPreview(root);
  }

  function initWithin(scope) {
    var root = scope.matches && scope.matches('[data-events-shell]')
      ? scope
      : scope.querySelector && scope.querySelector('[data-events-shell]');
    initEventsShell(root);
  }

  initWithin(document);

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });
})();
